import { extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Tag, utils } from '@costar/theme-ui';
import React from 'react';

function defaultRenderTags(getTagLabel, size, tagProps) {
  return function renderTag(value) {
    var getCustomizedTagProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils.noop;
    return /*#__PURE__*/React.createElement(React.Fragment, null, value.map(function (option, index) {
      return (
        /*#__PURE__*/
        // key is handle by getTagProps
        // eslint-disable-next-line react/jsx-key
        React.createElement(Tag, _extends({
          key: "autocomplete-tag-".concat(index),
          size: size,
          borderRadius: "pill"
        }, _objectSpread2(_objectSpread2(_objectSpread2({}, 'variant' in tagProps ? {
          useThemeVariant: true
        } : {
          color: 'primary',
          outline: true
        }), tagProps), getCustomizedTagProps({
          index: index,
          option: option
        }))), getTagLabel(option))
      );
    }));
  };
}

export default defaultRenderTags;
//# sourceMappingURL=default-render-tags.esm.js.map
